import { MAP_CONFIG } from 'config/constants'

export default () => [
  {
    id: 'clusters',
    type: 'circle',
    source: 'appi',
    'source-layer': 'aggs',
    maxzoom: MAP_CONFIG.MAXZOOM_AGGS,
    // filter: ['has', 'point_count'],
    filter: ['>', ['get', '_count'], 1],
    paint: {
      // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
      // with three steps to implement three types of circles, same color but different opacity
      'circle-color': [
        'case',
        ['>=', ['get', 'has_diagnostics.value'], 1],
        '#54B399', // color if diags
        '#C6C6C6', // default color
      ],
      'circle-opacity': ['step', ['get', '_count'], 0.7, 1000, 0.8, 10000, 1],
      'circle-radius': ['step', ['get', '_count'], 20, 1000, 30, 10000, 40],
    },
  },
  {
    id: 'cluster-count',
    type: 'symbol',
    source: 'appi',
    'source-layer': 'aggs',
    maxzoom: MAP_CONFIG.MAXZOOM_AGGS,
    // filter: ['has', 'point_count'],
    filter: ['>', ['get', '_count'], 1],
    layout: {
      'text-field': '{_count}',
      'text-font': ['Noto Sans Bold'], // fonts here: https://github.com/openmaptiles/fonts/tree/gh-pages
      'text-size': 12,
    },
  },
  {
    id: 'aggs-points',
    type: 'circle',
    source: 'appi',
    'source-layer': 'aggs',
    filter: ['==', ['get', '_count'], 1],
    maxzoom: MAP_CONFIG.MAXZOOM_AGGS,
    paint: {
      'circle-color': [
        'case',
        ['>=', ['get', 'has_diagnostics.value'], 1],
        '#54B399', // color if diags
        '#C6C6C6', // default color
      ],
      'circle-opacity': 0.7,
      'circle-stroke-width': 1,
      'circle-stroke-opacity': 0,
    },
  },
  {
    id: 'points',
    type: 'circle',
    source: 'appi',
    'source-layer': 'hits',
    minzoom: MAP_CONFIG.MAXZOOM_AGGS,
    paint: {
      'circle-color': [
        'case',
        ['==', ['get', 'TypeDiagnostic'], null],
        '#C6C6C6', // default color
        '#54B399', // color if diags
      ],
      'circle-opacity': 0.7,
      'circle-stroke-width': 1,
      'circle-stroke-color': [
        'case',
        ['==', ['get', 'TypeDiagnostic'], null],
        '#AAAAAA',
        '#41937C',
      ],
      'circle-stroke-opacity': 1,
    },
  },
]
